import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import Button from '@material-ui/core/Button';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import Typography from '@material-ui/core/Typography';

import { setActiveStep } from 'features/checkout/actions';

const CheckoutStepLabel = styled(StepLabel)`
  max-height: 24px;
  align-items: flex-start;
`;

const LabelTypography = styled(Typography)`
  display: flex;
  justify-content: space-between;
`;

const CheckoutStepInfo = styled(Typography)`
  font-weight: normal;
  margin-right: 24px;
`;

const ChangeButton = styled(Button)`
  visibility: ${props => (props.visible ? 'visible' : 'hidden')};
`;

const CheckoutStep = ({
  children,
  label,
  completedLabel,
  setActiveStep,
  ...other
}) => (
  <Step {...other}>
    <CheckoutStepLabel>
      <LabelTypography variant="h6">
        {label}
        <ChangeButton
          visible={other.completed && !other.active ? 1 : 0}
          color="primary"
          size="small"
          onClick={() => setActiveStep(other.index)}
        >
          Change
        </ChangeButton>
      </LabelTypography>
      {other.completed && !other.active && (
        <CheckoutStepInfo variant="caption" noWrap>
          {completedLabel}
        </CheckoutStepInfo>
      )}
    </CheckoutStepLabel>
    <StepContent>{children}</StepContent>
  </Step>
);

export default connect(state => ({}), { setActiveStep })(CheckoutStep);
